<template>
  <b-form-checkbox id="is_documents" class="mt-1"
                   value=1 unchecked-value=0
                   :disabled="isDisabled || isAllDocumentsAttached === null"
                   v-model="isAllDocumentsAttached">
    {{ 'is_all_documents_attached' | translate('global') }}
  </b-form-checkbox>
</template>
<script>
import statuses from '@/store/statuses';
import VuexTypes from '@/store/types/index';
import { mapActions, mapGetters } from 'vuex';

const OrdersTypes = VuexTypes.orders;
export default {
  data() {
    return {
      isAllDocumentsAttached: null,
      actions: {}
    };
  },
  props: ['isDisabled'],
  computed: {
    ...mapGetters('Orders', [
      'orderUpdateData',
      'orderUpdateAttachmentsStatus'
    ]),
  },
  watch: {
    orderUpdateData: {
      immediate: true,
      handler: function () {
        if (this.orderUpdateData.status === statuses.LOADED) {
          const data = this.orderUpdateData.data;
          this.isAllDocumentsAttached = data.order ? data.order['is_all_documents_attached'] ? 1 : 0 : null;
        }
      },
      deep: true
    },
    orderUpdateAttachmentsStatus: {
      handler: function () {
        if (this.orderUpdateAttachmentsStatus.status === statuses.LOADED) {
          this.alertSuccess();
        } else if (this.orderUpdateAttachmentsStatus.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
    isAllDocumentsAttached: function () {
      const data = this.orderUpdateData.data;
      const originalStatus = data['order'] ? data['order']['is_all_documents_attached'] ? 1 : 0 : null;
      if (originalStatus !== null && Number(this.isAllDocumentsAttached) !== Number(originalStatus)) {
        this.ORDER_UPDATE_ATTACHMENTS_STATUS({
          orderId: this.$route.params.id,
          updateData: {
            is_all_documents_attached: this.isAllDocumentsAttached
          },
        });
      }
    }
  },
  methods: {
    ...mapActions('Orders', [
      OrdersTypes.ORDER_UPDATE_ATTACHMENTS_STATUS,
    ]),
  }
};
</script>
